import {
  authSlice,
  navigationSlice,
  selectIsLogoutLoading,
  selectUnsavedChanges,
  useAppDispatch,
  useAppSelector,
} from '@ax/redux-store';
import { NavigationPages } from '@ax/constants';

export const useLogoutUser = () => {
  const unsavedChangesObject = useAppSelector(selectUnsavedChanges);
  const isLoading = useAppSelector(selectIsLogoutLoading);
  const dispatch = useAppDispatch();

  const logoutUser = () => {
    if (unsavedChangesObject.unsavedChanges) {
      dispatch(navigationSlice.actions.unsavedChangesModalOpened());
      dispatch(navigationSlice.actions.pageNavigationIgnored({ page: NavigationPages.Login }));
      return;
    }

    dispatch(authSlice.actions.logoutRequested());
  };

  return { logoutUser, isLoading };
};
